// extracted by mini-css-extract-plugin
export default {"modal":"record-modal_modal__J+rr5","container":"record-modal_container__L0otu"};